import { render, staticRenderFns } from "./myResourceApply.vue?vue&type=template&id=3989c457&scoped=true&"
import script from "./myResourceApply.vue?vue&type=script&lang=js&"
export * from "./myResourceApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3989c457",
  null
  
)

export default component.exports